import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/lang/page',
  ADD: '/dh-datamaint/lang/add',
  DELETE: '/dh-datamaint/lang/delete',
  DETAIL: '/dh-datamaint/lang/getById',
  UPDATE: '/dh-datamaint/lang/update',
  LIST: '/dh-datamaint/lang/list'
};

class LangModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE, { params: payload.data });
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async getLangList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.LIST, { params: payload.data });
    }
  };
}

export const langModule = new LangModule();
